import * as React from "react";
import { RouteProps, Redirect, Route } from "react-router-dom";
import LoginService, {
  isLoggedIn,
} from "../components/service/login/loginService";
import { urls } from "../components/login/loginConstants";

export interface IPostLoginProps extends RouteProps {}

const PostLogin: React.FC<IPostLoginProps> = (props) => {
  if (isLoggedIn()) {
    return <Route {...props} />;
  } else {
    LoginService.reUrl = props.location?.pathname;
    LoginService.fromUrl = props.location?.pathname; // todo this needs to be changed later
    return <Redirect to={urls.login} />;
  }
};

export default PostLogin;
